export namespace app{
    export namespace actions {
        export const removeConfirm = true;
        export const beforeEditConfirm = true;
        export const afterEditConfirm = true;
    }
    export const APP_ID = "web001";
    export namespace rules{
        export const minPasswordLength = 3;
        export const maxPasswordLength = 3;
    }
    export namespace ui{
        export const login = {
            username: "Mã số SV",
            password: "Mật khẩu"
        }
        export const showinfo = {
            username: "Mã số SV",
            usernamePlaceHold: "Nhập chính xác mã số sinh viên",
            requireinfofield: "Ngày/tháng/nămsinh-(dd/mm/yyyy)",
            requireinfofieldPlaceHold: "dd/mm/yyyy",
        }
    }
    export const DEFAULT_BACKEND_API = "http://101.99.31.149:1856";
    export const secrect_key="donothack!";
}